import { SET_INFO, SET_LANGUAGE } from '../constants/actions'

const initState = { language: 'th' }

export default (state = initState, action) => {
  switch (action.type) {
    case SET_INFO:
      return {
        ...state,
        [action.key]: action.value,
      }
    case SET_LANGUAGE:
      return {
        ...state,
        language: action.language,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/info.js